import common from './common.json'
import auth from './auth.json'
import nav from './nav.json'
import enums from './enums.json'
import errors from './errors.json'

const en = { common, auth, nav, enums, errors } as const
export default en
